import React from 'react';

const SolucionesPage = () => {
  return <div>
      
  </div>;
};

export default SolucionesPage;
